import { bigMath } from "../misc";
import {
	OrderItemInputLike,
	OrderItemOptionInputLike,
	VenueLike,
} from "../types";

export const applyVenueAddonsToItem = <
	TObj extends OrderItemInputLike | OrderItemOptionInputLike,
>({
	obj,
	venue,
}: {
	obj: TObj;
	venue: VenueLike;
}) => {
	const {
		vat,
		is_vat_buried,
		service_charge,
		is_service_charge_buried,
		service_charge_bd = 0,
		is_service_charge_bd_buried = false,
	} = venue;
	const { original_price } = obj;

	const vatAddOn = is_vat_buried ? bigMath.mul(original_price, vat) : 0;
	const serviceChargeAddOn = is_service_charge_buried
		? bigMath.mul(original_price, service_charge)
		: 0;
	const serviceChargeBdAddOn = is_service_charge_bd_buried
		? bigMath.mul(original_price, service_charge_bd)
		: 0;
	const listedPrice = bigMath.add(
		original_price,
		vatAddOn,
		serviceChargeAddOn,
		serviceChargeBdAddOn,
	);

	const listed_price = listedPrice;
	const original_price_addons = {
		vat: { amount: vatAddOn, percentage: vat },
		service_charge: { amount: serviceChargeAddOn, percentage: service_charge },
		service_charge_bd: {
			amount: serviceChargeBdAddOn,
			percentage: service_charge_bd,
		},
	};

	return { ...obj, listed_price, original_price_addons };
};
